<template>
  <b-modal modal-class="application-supporting-questions" :id="id" v-model="visible" lazy hide-footer :title="`How well do you know ${contactName}?`">
    <p>Please let us know how well you know them and add any supporting text to the referral. A recommendation is someone you know well enough to endorse, an introduction is a connection you thought it was worth showing the job to.</p>

    <p class="m-0"><strong>How well do you know them?*:</strong></p>
    <div class="application-referral-type mb-3 d-flex flex-row text-center card">
      <div class="flex-fill py-3 border-right" :class="{ selected: answers.type === 'RECOMMEND' }" @click="() => answers.type = 'RECOMMEND'">Recommend 💬</div>
      <div class="flex-fill py-3"  :class="{ selected: answers.type === 'INTRODUCE' }" @click="() => answers.type = 'INTRODUCE'">Introduce 🤝</div>
    </div>

    <p class="m-0"><strong>Additional information:</strong></p>
    <b-textarea class="mb-3" v-model="answers.message"/>

    <p>Thanks for making this referral!</p>
    <b-button @click="updateApplication" variant="primary">Save answers</b-button>
  </b-modal>
</template>

<script>
import UpdateOneJobApplicationMutation from '@/graphql/mutations/JobApplicationUpdateOne.gql';

export default {
  name: 'ApplicationSupportingQuestions',
  props: {
    id: {
      type: String,
    },
    application: {
      type: Object,
    },
    contact: {
      type: Object,
    },
  },
  data: () => ({
    answers: {
      type: 'RECOMMEND',
      message: null,
    },
    visible: false,
  }),
  created() {
    const { type, message } = this.application.userAnswers || {};
    if (type) {
      this.answers.type = type;
    }
    if (message) {
      this.answers.message = message;
    }
  },
  computed: {
    contactName() {
      return this.application.fullName;
    },
  },
  methods: {
    async updateApplication() {
      try {
        const { id: applicationID } = this.application;
        const { type, message } = this.answers;
        this.$assert(applicationID, new Error('Missing applicationID'));
        this.$assert(type, new Error('Missing type from answer block'));

        await this.$apollo.mutate({
          mutation: UpdateOneJobApplicationMutation,
          variables: {
            applicationID,
            update: {
              userAnswers: {
                type,
                message,
              },
            },
          },
        });

        this.$notification({
          title: 'Application successfully updated!',
          message: `Your answers for ${this.contactName}'s application were saved successfully`,
          variant: 'success',
        });

        this.visible = false;
      } catch (err) {
        this.$notifyErr(err, { prepend: 'Failed to save your answers:' });
      }
    },
  },
};
</script>

<style lang="scss">
.application-supporting-questions {
  .application-referral-type {
    user-select: none;

    .selected {
      background: rgba(25, 212, 22, 0.15);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modals/application-supporting-questions.vue